//TOOLTIPS DESCRIPTION FOR DEPLOY DIALOG
export const DEPLOY_DIALOG_STRINGS = {
    PEAK_MARGIN_DESCRIPTION: `It is the maximum potential amount required to purchase securities as per exchange.`
}
